
export const BuyerSubscriptionMutation = new TypedDocumentString(`
    mutation BuyerSubscriptionMutation($input: InputBuyerSubscription!) {
  buyerSubscription(input: $input) {
    responseInfo {
      ...ResponseInfo
      __typename
    }
    check {
      ...BuyerSubscriptionsItem
      __typename
    }
    __typename
  }
}
    fragment BuyerSubscriptionsItem on BuyerSubscriptionsItem {
  id
  newsletter
  reviewRemindersEnabled
  __typename
}
fragment ResponseInfo on ResponseInfo {
  success
  message
  status
  error
  __typename
}`, {"hash":"50cc441753f0ff8076550b99019a0d5834f2cc3998a7133ae3a163099dbd6819"});